import BRecipeList from "./BRecipeList";

const DEBOUNCE_MS = 400;

function triggerSearch(input) {
    const list = input.closest("[data-list]");
    if (!list) {
        return;
    }

    BRecipeList.setQuery(list, input.value.trim());
    BRecipeList.reload(list);
}

export default {
    initialize() {
        document.querySelectorAll(".rcp-filter input[name=\"query\"]").forEach((input) => {
            let debounceTimer = null;

            input.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    clearTimeout(debounceTimer);
                    triggerSearch(input);
                }
            });

            input.addEventListener("input", () => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => triggerSearch(input), DEBOUNCE_MS);
            });

            const searchBtn = input.closest(".search")?.querySelector(".btn");
            if (searchBtn) {
                searchBtn.style.cursor = "pointer";
                searchBtn.addEventListener("click", () => {
                    clearTimeout(debounceTimer);
                    triggerSearch(input);
                });
            }

            document.addEventListener("keydown", (event) => {
                if (event.key === "/" && event.shiftKey) {
                    const tag = document.activeElement?.tagName;
                    if (tag === "INPUT" || tag === "TEXTAREA" || document.activeElement?.isContentEditable) {
                        return;
                    }
                    event.preventDefault();
                    input.focus();
                    input.select();
                }
            });
        });
    },
};
